import { cn } from '@/shadcn-ui/utils';
import { Form, Link } from 'react-router';
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from '@/shadcn-ui/navigation-menu';
import HeaderViewCarsButton from './header-view-cars-button';
import { Button } from '@/shadcn-ui/button';
import { useDisableSpaNavigation } from '@/util-react-router/hooks/use-disable-spa-navigation';

export interface HeaderNavigationMenuProps {
  isLoggedIn: boolean;
  dark?: boolean;
  hideHomeLink?: boolean;
  hideCatalogLink?: boolean | 'mobile';
  whyFlexcarButtonOnClickDelegate?: () => void;
  direction?: 'horizontal' | 'vertical';
  className?: string;
  navLinkClassName?: string;
}

export default function HeaderNavigationMenu({
  isLoggedIn,
  dark = false,
  hideHomeLink = false,
  hideCatalogLink = false,
  whyFlexcarButtonOnClickDelegate,
  direction = 'horizontal',
  className,
  navLinkClassName,
}: HeaderNavigationMenuProps) {
  const { disableSpaNavigation } = useDisableSpaNavigation();

  return (
    <NavigationMenu className={className}>
      <NavigationMenuList
        className={cn({
          'ml-0 flex-col items-start gap-2': direction === 'vertical',
        })}
      >
        {!hideHomeLink ? (
          <NavigationMenuItem className="ml-0">
            <Link
              to="/"
              reloadDocument={disableSpaNavigation}
              className={navigationMenuTriggerStyle(
                {
                  'link-nav-dark': dark,
                },
                navLinkClassName
              )}
            >
              Home
            </Link>
          </NavigationMenuItem>
        ) : null}

        {whyFlexcarButtonOnClickDelegate ? (
          <NavigationMenuItem className="ml-0">
            <Button
              variant="clear"
              onClick={whyFlexcarButtonOnClickDelegate}
              className={navigationMenuTriggerStyle(
                {
                  'link-nav-dark': dark,
                },
                navLinkClassName
              )}
            >
              Why Flexcar?
            </Button>
          </NavigationMenuItem>
        ) : null}

        <NavigationMenuItem className="ml-0">
          <Link
            to="/how-it-works"
            reloadDocument={disableSpaNavigation}
            className={navigationMenuTriggerStyle(
              {
                'link-nav-dark': dark,
              },
              navLinkClassName
            )}
          >
            How it works
          </Link>
        </NavigationMenuItem>

        {isLoggedIn ? (
          <NavigationMenuItem className="ml-0">
            <Link
              to="/account"
              reloadDocument={disableSpaNavigation}
              className={navigationMenuTriggerStyle(
                {
                  'link-nav-dark': dark,
                },
                navLinkClassName
              )}
            >
              Account
            </Link>
          </NavigationMenuItem>
        ) : null}

        <NavigationMenuItem className="ml-0">
          {isLoggedIn ? (
            <Form action="/logout" method="post">
              <button
                type="submit"
                className={navigationMenuTriggerStyle(
                  {
                    'link-nav-dark': dark,
                  },
                  navLinkClassName
                )}
              >
                Logout
              </button>
            </Form>
          ) : (
            <Link
              to="/login"
              reloadDocument={disableSpaNavigation}
              className={navigationMenuTriggerStyle(
                {
                  'link-nav-dark': dark,
                },
                navLinkClassName
              )}
            >
              Log in
            </Link>
          )}
        </NavigationMenuItem>

        {hideCatalogLink !== true ? (
          <NavigationMenuItem className="ml-4 mt-4 sm:mt-0">
            <HeaderViewCarsButton
              dark={dark}
              className={cn(
                {
                  'hidden sm:flex':
                    hideCatalogLink === 'mobile' && direction !== 'vertical',
                },
                navLinkClassName
              )}
            />
          </NavigationMenuItem>
        ) : null}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
